export default __webpack_public_path__ + "static/media/facebook.e51ab08a.svg";